
import { Box, Card } from "@mui/material";
import { useGetStateListQuery } from "features/dashboard/RiskManagement/RiskManagementApiSlice";
import { useGetAllAnalyticsDataMutation } from "features/masterdata/MasterApiSlice";
import { useEffect, useState } from "react";
import Select from "react-select";
import { DateRangePicker } from "rsuite";
import { useGetDistrictByStateQuery } from "services/locationApiSlice";
import TopLocationChart from "components/analytics/TopLocationChart";
import { SectionHeader } from "components/analytics/BankingAnalytics/Components/AnalyticsCard";
import { selectCurrentRoles } from "features/auth/authSlice";
import { useSelector } from "react-redux";
import InsuranceSection from "components/analytics/BankingAnalytics/Components/InsuranceSection";
import InsuranceMisChart from "./InsuranceMisChart";
const InsuranceMisAnalytics = () => {
  const [
    getAllAnalyticsData,
    { data: analyticsData },
  ] = useGetAllAnalyticsDataMutation();
   const RolesFromToken = useSelector(selectCurrentRoles);
 
  const [stateId, setStateId] = useState(null);
  const [districtId, setDistrictId] = useState(null);
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [SelectedFle, setSelectedFle] = useState("");
  const [dateRange, setDateRange] = useState(undefined);
  const { data: getStates } = useGetStateListQuery();
  const { data: dataDistrict } = useGetDistrictByStateQuery(stateId, {
    skip: !stateId,
  });
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  useEffect(() => {
    if (getStates?.data?.results) {
      setStateList(getStates.data.results);
    }
  }, [getStates]);

  useEffect(() => {
    if (dataDistrict?.data?.results) {
      setDistrictList(dataDistrict.data.results);
    }
  }, [dataDistrict]);
  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, "0")}-${String(
      d.getMonth() + 1
    ).padStart(2, "0")}-${d.getFullYear()}`;
  };

  useEffect(() => {
    const [from, to] = dateRange || [];

    const payload = {
      ...(stateName && { state_name: stateName }),
      ...(districtName && { district_name: districtName }),
      ...(from ? { from_date: formatDate(from) } : {}),
      ...(to ? { to_date: formatDate(to) } : {}),
      ...(SelectedFle && { agent_id: SelectedFle }),
      top_number: 10,
    };

    getAllAnalyticsData(payload);
  }, [stateName, districtName, dateRange, SelectedFle, getAllAnalyticsData]);

  const onLocationChange = (selectedOption) => {
    if (!selectedOption) return;

    const { ConditionName, value, label } = selectedOption;

    if (ConditionName === "state") {
      setStateId(value);
      setStateName(label);
      setDistrictId(null);
      setDistrictName("");
    }

    if (ConditionName === "district") {
      setDistrictId(value);
      setDistrictName(label);
    }
  };

  const handleClear = (type) => {
    if (type === "state") {
      setStateId(null);
      setStateName("");
      setDistrictId(null);
      setDistrictName("");
    } else if (type === "district") {
      setDistrictId(null);
      setDistrictName("");
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "40px",
      height: "40px",
      fontSize: "13px",
      zIndex: 100,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 3000,
    }),
  };

  const handleStateOptions = () =>
    [...stateList]
      .sort((a, b) => a.state_name.localeCompare(b.state_name))
      .map((state) => ({
        value: state.state_code,
        label: state.state_name,
        ConditionName: "state",
      }));

  const handleDistrictOptions = () =>
    [...districtList]
      .sort((a, b) => a.district_name.localeCompare(b.district_name))
      .map((district) => ({
        value: district.district_code,
        label: district.district_name,
        ConditionName: "district",
      }));

  const handleDateChange = (range) => {
    if (!range || range.length === 0) {
      setDateRange([]);
    } else {
      setDateRange(range);
    }
  };
   const insurance = analyticsData?.data?.insurance;
   const formattedInsuranceStateData =
    insurance?.top_states?.map((item) => ({
      name: item.state_name,
      value: item.total_count,
    })) || [];

  const formattedInsuranceDistrictData =
    insurance?.top_districts?.map((item) => ({
      name: item.district_name,
      value: item.total_count,
    })) || [];
  return (
    <div>
   
      <Box
        sx={{ p: 1 }}
        className="position-relative container-fluid px-lg-2 mt-4">
        <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center mb-3 gap-3 ">
          <div
            className="d-flex flex-wrap justify-content-start  gap-2 col-12 col-lg-9">
            <div
              className="flex-grow-1 flex-lg-grow-0"
              style={{ minWidth: "220px" }}>
              <Select
                options={handleStateOptions()}
                placeholder="State"
                value={
                  stateId
                    ? {
                        value: stateId,
                        label: stateName,
                        ConditionName: "state",
                      }
                    : null
                }
                onChange={(option) => {
                  if (!option) handleClear("state");
                  else onLocationChange(option);
                }}
                styles={customStyles}
                isClearable
              />
            </div>
            <div
              className="flex-grow-1 flex-lg-grow-0"
              style={{ minWidth: "220px" }}>
              <Select
                options={handleDistrictOptions()}
                placeholder="District"
                value={
                  districtId
                    ? {
                        value: districtId,
                        label: districtName,
                        ConditionName: "district",
                      }
                    : null
                }
                onChange={(option) => {
                  if (!option) handleClear("district");
                  else onLocationChange(option);
                }}
                styles={customStyles}
                isDisabled={!stateId}
                isClearable
              />
            </div>    
            <div
              className="flex-grow-1 flex-lg-grow-0 analytics-date"
              style={{ minWidth: "220px" }}>
              <DateRangePicker
                style={{ width: "100%" }}
                placeholder="Select Date Range"
                value={dateRange}
                onChange={handleDateChange}
                format="dd MMM yyyy"
                placement="auto"
                shouldDisableDate={(date) => date > new Date()}/>
            </div>
          </div>
        </div>
       <SectionHeader title="Insurance Analytics" />
               {console.log("  const banking = analyticsData?.data?.banking",analyticsData?.data?.insurance)}
          <InsuranceMisChart data={analyticsData?.data?.insurance?.summary}/>
        <InsuranceSection
          analyticsData={analyticsData}
          getAllAnalyticsData={getAllAnalyticsData}
          mainStateName={stateName}/>
        <div className="d-flex flex-column flex-lg-row gap-4 mb-5">
          <Card className="rounded w-100">
            <h5 className="bg-secondary2" style={{ padding: "12px 15px" }}>
              Top Performing States - Insurance
            </h5>
            <TopLocationChart
              location={formattedInsuranceStateData}
              showLoading={false}/>
          </Card>
          <Card className="rounded w-100">
            <h5 className="bg-secondary2" style={{ padding: "12px 15px" }}>
              Top Performing Districts - Insurance
            </h5>
            <TopLocationChart
              location={formattedInsuranceDistrictData}
              showLoading={false}/>
          </Card>
        </div>      
      </Box>
    </div>
  );
};

export default InsuranceMisAnalytics;
